export const Services = {
   "PostContact": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "POST",
      "descrp": "method to add contact  ******RR********"
   },
   "GetInfoCustomer": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method to obtain contacts and users related to the customer, for the modality of view and edition ******RR********"
   },
   "DeleteContact": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method to deleted contact  ******RR********"
   },
   "PutCustomers": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "PUT",
      "descrp": "CUSTOMER UPDATE method ******RR********"
   },
   "GetRole": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method to obtain roles the user ******RR********"
   },
   "PostUser": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "POST",
      "descrp": "method to add User ******RR********"
   },
   "validateEmail": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "POST",
      "descrp": "method to add User ******RR********"
   },
   "GetUser": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method to obtain user ******RR******** "
   },
   "GetInfoUser": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method to obtain clientes and users related to the customer, for the modality of view and edition ******RR********"
   },
   "PutUser": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "PUT",
      "descrp": "User UPDATE method ******RR********"
   },
   "PostCustomer": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "POST",
      "descrp": "User UPDATE method ******RR********"
   },
   "GetListCustomer": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method TO OBTAIN CUSTOMER LIST ******RR********"
   },
   "DeleteCustomer": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "DELETE",
      "descrp": "DELETE CUSTOMER FOR ID ******RR********"
   },
   "GetCountrys": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "ADMIN ******RR********"
   },
   "GetModuls": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "ADMIN ******RR********"
   },
   "DeleteUser": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "DELETE",
      "descrp": "GET REPORTS CATALOGS ******RR********"
   },
   "GET_REPORTS_CATALOGS": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "GET REPORTS CATALOGS ******RR********"
   },
   "GET_REPORTS_RELATION": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "GET REPORTS CATALOGS  ******RR********"
   },
   "POST_LIST_GROUP": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "POST",
      "descrp": "method TO OBTAIN GROUP LIST ******RR********"
   },
   "GET_LIST_GROUP": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method TO OBTAIN GROUP LIST ******RR********"
   },
   "GET_INFO_GROUP": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "method to obtain clients related to the grupos, for the modality of view and edition ******RR********"
   },
   "PUT_GROUP_ID": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "PUT",
      "descrp": "User UPDATE method ******RR********"
   },
   "DELETE_GROUP_FORID": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "DELETE",
      "descrp": "GET REPORTS CATALOGS ******RR********"
   }
}